import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConclusionScanPreviewComponent} from './components/conclusion-scan-preview/conclusion-scan-preview.component';
import {
    ConclusionScanFormModalComponent
} from '@modules/conclusion/components/conclusion-scan-form-modal/conclusion-scan-form-modal.component';
import {ModalModule} from '@components/modal/modal.module';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {FilesUploaderModule} from '@components/files-uploader/files-uploader.module';
import {ReactiveFormsModule} from '@angular/forms';
import {FilePreviewModule} from '@components/file-preview/file-preview.module';
import {LayoutModule} from '../../layout-components/layout.module';

@NgModule({
    declarations: [
        ConclusionScanPreviewComponent,
        ConclusionScanFormModalComponent,
    ],
    entryComponents: [
        ConclusionScanFormModalComponent
    ],
    exports: [
        ConclusionScanPreviewComponent
    ],
    imports: [
        CommonModule,
        ModalModule,
        FormFieldModule,
        FilesUploaderModule,
        ReactiveFormsModule,
        FilePreviewModule,
        LayoutModule,
    ]
})
export class ConclusionComponentsModule {
}
